import React from 'react'

import { SubjectPersonAvatar } from './InboxListItemPreview.styles'

interface PersonPreviewProps {
  name?: string | null
  src?: string | null
}

/** Round avatar for the person behind a notification (e.g. the inviter). */
export const PersonPreview = ({ name, src }: PersonPreviewProps) => {
  const displayName = name ?? 'Someone'

  return src ? (
    <SubjectPersonAvatar
      flavour="image"
      size="32px"
      name={displayName}
      src={src}
    />
  ) : (
    <SubjectPersonAvatar flavour="color" size="32px" name={displayName} />
  )
}
